module.exports = __webpack_public_path__ + "static/media/image1.b75c8361.jpg";